import React from 'react';

interface DateTemplateProps {
  date?: string | null;
  includeTime?: boolean;
}

/**
 * Formats and displays a date.
 */
export const DateTemplate: React.FC<DateTemplateProps> = ({ date, includeTime = false }) => {
  if (!date) return <span>-</span>;

  const dateObj = new Date(date);
  const formatted = includeTime
    ? dateObj.toLocaleString('en-US', {
        month: '2-digit',
        day: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    : dateObj.toLocaleDateString();

  return <span>{formatted}</span>;
};

/** Syncfusion grid template for service date */
export const serviceDateTemplate = (props: { serviceDate?: string | null }) => (
  <DateTemplate date={props.serviceDate} />
);

/** Syncfusion grid template for created date */
export const createdDateTemplate = (props: { createdDate?: string | null }) => (
  <DateTemplate date={props.createdDate} />
);

/** Syncfusion grid template for writeoff start date */
export const writeoffStartDateTemplate = (props: { writeoffStartDate?: string | null }) => (
  <DateTemplate date={props.writeoffStartDate} />
);

export default DateTemplate;
